export default __webpack_public_path__ + "static/media/ImageAutomationTimer.e28f5b3b.gif";